/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiListGroupAvailabilityRequestFromJSON(json) {
    return StreemApiListGroupAvailabilityRequestFromJSONTyped(json, false);
}
export function StreemApiListGroupAvailabilityRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companyCodeOrSid': !exists(json, 'company_code_or_sid') ? undefined : json['company_code_or_sid'],
        'groupName': !exists(json, 'group_name') ? undefined : json['group_name'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'pageToken': !exists(json, 'page_token') ? undefined : json['page_token'],
        'pageSize': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}
export function StreemApiListGroupAvailabilityRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'company_code_or_sid': value.companyCodeOrSid,
        'group_name': value.groupName,
        'status': value.status,
        'page_token': value.pageToken,
        'page_size': value.pageSize,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiListGroupAvailabilityRequestStatus;
(function (StreemApiListGroupAvailabilityRequestStatus) {
    StreemApiListGroupAvailabilityRequestStatus["AVAILABLE"] = "AVAILABILITY_STATUS_AVAILABLE";
    StreemApiListGroupAvailabilityRequestStatus["CONFIRMING"] = "AVAILABILITY_STATUS_CONFIRMING";
    StreemApiListGroupAvailabilityRequestStatus["INVALID"] = "AVAILABILITY_STATUS_INVALID";
    StreemApiListGroupAvailabilityRequestStatus["INCALL"] = "AVAILABILITY_STATUS_IN_CALL";
    StreemApiListGroupAvailabilityRequestStatus["NOTAVAILABLE"] = "AVAILABILITY_STATUS_NOT_AVAILABLE";
    StreemApiListGroupAvailabilityRequestStatus["OFFLINE"] = "AVAILABILITY_STATUS_OFFLINE";
    StreemApiListGroupAvailabilityRequestStatus["RESERVED"] = "AVAILABILITY_STATUS_RESERVED";
})(StreemApiListGroupAvailabilityRequestStatus || (StreemApiListGroupAvailabilityRequestStatus = {}));
//# sourceMappingURL=StreemApiListGroupAvailabilityRequest.js.map